import LessonIcon from 'src/assets/icons/lesson_icon.svg?react';
import TimerIcon from 'src/assets/icons/time_icon.svg?react';
import ContentVideo from '@components/content-video/ContentVideo';
import styles from './CollectionList.module.scss';
import { getMediaAbsolutePath } from '@src/services/File';
import Button from "@components/button/Button";
import { collectionTypeOptions } from '@src/constants';

function CollectionCard(props) {
    const {
        name,
        duration,
        bannerImage,
        bannerVideo,
        grade,
        sllLessons,
        collectionType
    } = props.collection;
    const count = sllLessons?.length || 0;

    const isThemeType = collectionType === collectionTypeOptions[2].value

    const collectionCover = (type: String) => {
        switch (type) {
          case collectionTypeOptions[0].value: {
            return (
                <div className={styles.lessonContainer}>
                    <p className={styles.individualLessonTitle}>Displayed as Individual Lessons</p>
                    <p className={styles.gradeTitle}>{grade}</p>
                </div>);
          }
          case collectionTypeOptions[1].value: {
            return (
                <div className={styles.imageContainer}>
                    {!!bannerImage ? (
                        <img src={getMediaAbsolutePath(bannerImage) || ""} alt="cover" width={'100%'}/>
                    ) : null}
                    {!bannerImage && bannerVideo ? (
                        <ContentVideo data={bannerVideo} metaData={bannerVideo?.metaData} autoPlay={false} isCollection={true}/>
                    ) : null}
                </div>
            );
          }
          case collectionTypeOptions[2].value: {
            return (
                <>
                    <div className={styles.themeContainerRectangle1}></div>
                    <div className={styles.themeContainerRectangle2}></div>
                    <div className={styles.themeContainerRectangle3}></div>
                    <div className={styles.themeContainer}>
                        <p className={styles.titleText}>Displays as Theme</p>
                        <p className={styles.gradeTitle}>{grade}</p>
                    </div>
                </>
            );
          }
          default: {
            return (
                <div className={styles.imageContainer}>
                    {!!bannerImage ? (
                        <img src={getMediaAbsolutePath(bannerImage) || ""} alt="cover" width={'100%'}/>
                    ) : null}
                    {!bannerImage && bannerVideo ? (
                        <ContentVideo data={bannerVideo} metaData={bannerVideo?.metaData} autoPlay={false} />
                    ) : null}
                </div>
            );
          }
        }
      }

    return (
        <div className={styles.collectionCardContainer} onClick={() => props.onCardClick && props.onCardClick(sllLessons)}>
            {isThemeType ? (
                <>
                    <div className={styles.themeContainerRectangle1}></div>
                    <div className={styles.themeContainerRectangle2}></div>
                    <div className={styles.themeContainerRectangle3}></div>
                </>
            ) : (
                <>
                    <div className={styles.containerRectangle1}></div>
                    <div className={styles.containerRectangle2}></div>
                    <div className={styles.containerRectangle3}></div>
                </>
            )}
            {collectionCover(collectionType)}
            <div className={styles.lessonMarkContainer}>
                <div className={styles.lessonCountContainer}>
                    <LessonIcon />
                    <p className={styles.lessonTitle}>
                        {count || 0} Lessons
                    </p>
                </div>
                <div className={styles.lessonDurationContainer}>
                    <TimerIcon />
                    <p className={styles.lessonDurationTitle}>
                        {count || 0} x {duration || 0} mins
                    </p>
                </div>
            </div>
            <div className={styles.titleContainer}>
                <p className={styles.title}>
                    {name || ""}
                </p>
                <Button
                    onClick={() => props.onEditCollection(props.collection.id)}
                    className={styles.addBtn}
                    label={"Edit"}
                    color='orange'
                />
            </div>
           
        </div>
    )
}

export default CollectionCard;